import { render, staticRenderFns } from "./StoreDetails.vue?vue&type=template&id=01b59d94&scoped=true"
import script from "./StoreDetails.vue?vue&type=script&lang=js"
export * from "./StoreDetails.vue?vue&type=script&lang=js"
import style0 from "./StoreDetails.vue?vue&type=style&index=0&id=01b59d94&prod&lang=scss&scoped=true"
import style1 from "./StoreDetails.vue?vue&type=style&index=1&id=01b59d94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b59d94",
  null
  
)

export default component.exports